<template>
  <div class="content tdi-page">
    <div class="row-data tdi-toolbar-card">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">Quản lý phiếu thu học sinh</p>
          <p class="tdi-card-subtitle">Tìm kiếm và theo dõi phiếu thu theo lớp/nhóm/gói.</p>
        </div>
        <div class="tdi-card-head-actions">
          <el-button
            plain
            icon="el-icon-refresh-left"
            size="small"
            class="tdi-reset-btn"
            @click="handleResetFilters"
          >
            Làm mới bộ lọc
          </el-button>
        </div>
      </div>

      <el-form
        ref="searchFormRef"
        :model="searchRequest"
        :rules="searchRules"
        label-position="top"
        class="tdi-form-grid"
        :class="{ 'tdi-form-grid--package': isPackageMode }"
      >
        <el-form-item label="Phạm vi" prop="targetType" class="tdi-form-item">
          <el-radio-group v-model="searchRequest.targetType" @change="handleTargetTypeChange" class="sk-segmented-control">
            <el-radio-button label="CLASS">Theo lớp</el-radio-button>
            <el-radio-button label="GROUP">Theo nhóm</el-radio-button>
            <el-radio-button label="PACKAGE">Theo gói</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- Tháng đơn: chỉ hiển thị khi không phải PACKAGE -->
        <el-form-item v-if="!isPackageMode" label="Tháng" prop="monthAndYear" class="tdi-form-item" :class="{ 'is-filter-active': isFilterActive('monthAndYear') }">
          <el-date-picker
            v-model="searchRequest.monthAndYear"
            type="month"
            value-format="M-yyyy"
            format="MM-yyyy"
            placeholder="Chọn tháng"
            :clearable="false"
            style="width: 135px"
            @change="handleMonthChange"
          />
        </el-form-item>

        <!-- Từ tháng / Đến tháng: chỉ hiển thị khi PACKAGE -->
        <el-form-item v-if="isPackageMode" label="Từ tháng" prop="fromMonthAndYear" class="tdi-form-item">
          <el-date-picker
            v-model="searchRequest.fromMonthAndYear"
            type="month"
            value-format="M-yyyy"
            format="MM-yyyy"
            placeholder="Từ tháng"
            :clearable="false"
            style="width: 135px"
            @change="handlePackageDateChange"
          />
        </el-form-item>

        <el-form-item v-if="isPackageMode" label="Đến tháng" prop="toMonthAndYear" class="tdi-form-item">
          <el-date-picker
            v-model="searchRequest.toMonthAndYear"
            type="month"
            value-format="M-yyyy"
            format="MM-yyyy"
            placeholder="Đến tháng"
            :clearable="false"
            style="width: 135px"
            @change="handlePackageDateChange"
          />
        </el-form-item>

        <el-form-item label="Trạng thái học sinh" class="tdi-form-item" :class="{ 'is-filter-active': isFilterActive('kidStatus') }">
          <el-select
            v-model="searchRequest.kidStatus"
            placeholder="Chọn trạng thái"
            style="width: 150px"
            @change="handleSearch"
          >
            <el-option
              v-for="item in kidStatusList"
              :key="item.key"
              :value="item.key"
              :label="item.label || item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="isClassMode || isPackageMode" label="Khối" class="tdi-form-item">
          <el-select
            v-model="searchRequest.idGrade"
            :placeholder="isPackageMode ? 'Tất cả' : 'Chọn khối'"
            :clearable="isPackageMode"
            style="width: 140px"
            @change="handleGradeChange"
          >
            <el-option v-if="isPackageMode" label="Tất cả" value="" />
            <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="isClassMode || isPackageMode" label="Lớp" prop="idClass" class="tdi-form-item">
          <el-select
            v-model="searchRequest.idClass"
            :placeholder="isPackageMode ? 'Tất cả' : 'Chọn lớp'"
            :clearable="isPackageMode"
            style="width: 175px"
            @change="handleSearch"
          >
            <el-option v-if="isPackageMode" label="Tất cả" value="" />
            <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="isGroupMode" label="Nhóm" prop="idGroup" class="tdi-form-item">
          <el-select
            v-model="searchRequest.idGroup"
            placeholder="Chọn nhóm"
            style="width: 220px"
            @change="handleSearch"
          >
            <el-option
              v-for="item in kidGroupList"
              :key="item.id"
              :value="item.id"
              :label="item.nameGroup"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="isPackageMode" label="Gói dịch vụ" prop="idPackage" class="tdi-form-item">
          <el-select
            v-model="searchRequest.idPackage"
            placeholder="Chọn gói"
            style="width: 220px"
            @change="handleSearch"
          >
            <el-option
              v-for="item in packageList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái phiếu thu" class="tdi-form-item" :class="{ 'is-filter-active': isFilterActive('status') }">
          <el-select
              v-model="searchRequest.status"
              clearable
              placeholder="Tất cả"
              style="width: 150px"
              @change="handleSearch"
          >
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tìm theo tên học sinh" class="tdi-form-item" :class="{ 'is-filter-active': isFilterActive('name') }">
          <el-input
            v-model="searchRequest.name"
            clearable
            prefix-icon="el-icon-search"
            placeholder="Nhập tên học sinh"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
        </el-form-item>

        <el-form-item label="Đợt thu" class="tdi-form-item" :class="{ 'is-filter-active': isFilterActive('turn') }">
          <el-select
              v-model="searchRequest.turn"
              placeholder="Tất cả"
              style="width: 110px"
              @change="handleSearch"
          >
            <el-option
                v-for="turn in collectionTurns"
                :key="turn"
                :value="turn"
                :label="`Đợt ${turn}`"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="row-data tdi-table-card">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">Danh sách phiếu thu</p>
          <p class="tdi-card-subtitle">Hiển thị {{ tableData.length }} / {{ totalRecord }} bản ghi.</p>
        </div>
        <div style="display: flex; gap: 15px; align-items: center;">
          <div v-if="multipleSelection.length > 0">
            <span class="tdi-selection-count">
              Đã chọn: <strong>{{ multipleSelection.length }}</strong> / <strong>{{ tableData.length }}</strong>
            </span>
          </div>
          <el-popover placement="bottom-end" width="220" trigger="click">
            <div class="ipd-settings-menu" style="display: flex; flex-direction: column; max-height: 400px; overflow-y: auto;">
              <el-checkbox v-model="visibleColumns.nickName">Biệt danh</el-checkbox>
              <el-checkbox v-model="visibleColumns.className">Tên lớp</el-checkbox>
              <el-checkbox v-model="visibleColumns.hideReceipt">Hiển thị</el-checkbox>
              <el-checkbox v-model="visibleColumns.parentUnread">PH đã xem</el-checkbox>
              <el-checkbox v-model="visibleColumns.invoiceCode">Mã phiếu thu</el-checkbox>
              <el-checkbox v-model="visibleColumns.additionalInfo">Thông tin bổ sung</el-checkbox>
              <el-checkbox v-model="visibleColumns.unpaidInvoices">Phiếu chưa thanh toán</el-checkbox>
              <el-checkbox v-model="visibleColumns.releasedInvoices">Phiếu đã phát hành</el-checkbox>
              <el-checkbox v-model="visibleColumns.onlinePaymentStatus">Trạng thái TT thanh toán</el-checkbox>
              <el-checkbox v-model="visibleColumns.status">Trạng thái</el-checkbox>
              <el-checkbox v-model="visibleColumns.turn">Đợt</el-checkbox>
              <el-checkbox v-model="visibleColumns.monthYear">Tháng-Năm</el-checkbox>
              <el-checkbox v-model="visibleColumns.beforeMoney">Thiếu/Thừa phiếu thu trước</el-checkbox>
              <el-checkbox v-model="visibleColumns.sumMoney">Phải thu</el-checkbox>
              <el-checkbox v-model="visibleColumns.collectedMoney">Đã thu</el-checkbox>
              <el-checkbox v-model="visibleColumns.cashMoney">Tiền mặt</el-checkbox>
              <el-checkbox v-model="visibleColumns.transferMoney">Chuyển khoản</el-checkbox>
              <el-checkbox v-model="visibleColumns.afterMoney">Thiếu/Thừa còn lại</el-checkbox>
<!--              <el-divider style="margin: 8px 0;"></el-divider>-->
              <el-checkbox v-model="visibleColumns.feeColumns">Các khoản thu</el-checkbox>
            </div>
            <el-button slot="reference" type="primary" plain icon="el-icon-setting" size="small">Thiết lập cột</el-button>
          </el-popover>
        </div>
      </div>

      <div class="tdi-table-wrapper">
        <el-table
          ref="invoiceTableRef"
          :data="tableData"
          class="sk-table tdi-main-table"
          :class="{ 'tdi-table--package': isPackageMode }"
          border
          v-loading="isLoading"
          :empty-text="emptyText"
          :max-height="$tableMaxHeight"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0)"
          :summary-method="getSummaries"
          show-summary
          row-key="id"
          @selection-change="handleSelectionChange"
          @header-click="handleTableHeaderClick"
        >
          <el-table-column type="selection" width="52" align="center" />
          <el-table-column type="index" label="STT" width="50" align="center" fixed="left" />

          <el-table-column label="Họ tên" prop="fullName" width="250" fixed="left" align="left">
            <template slot-scope="{ row }">
              <el-tooltip :content="`Mã HS: ${row.studentCode}`" placement="top">
                <span class="tdi-student-name-cell">{{ row.fullName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.nickName" label="Biệt danh" prop="nickName" width="130" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.nickName || "—" }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="visibleColumns.className" label="Tên lớp" prop="className" width="170" align="left" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span>{{ row.className || "—" }}</span>
            </template>
          </el-table-column>
          <!-- New column for hideReceipt -->
          <el-table-column v-if="visibleColumns.hideReceipt" label="Hiển thị" width="100" align="center">
            <template slot-scope="{ row }">
              <el-checkbox :disabled="row.status === 'UNBILLED'" v-model="row.hideReceipt" @change="handleHideReceiptChange(row)"></el-checkbox>
            </template>
          </el-table-column>

          <!-- New column for parentUnread -->
          <el-table-column v-if="visibleColumns.parentUnread" label="PH đã xem" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.parentUnread ? 'success' : 'info'" size="mini" effect="light">
                {{ row.parentUnread ? 'Đã xem' : 'Chưa xem' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.invoiceCode" label="Mã phiếu thu" prop="invoiceCode" width="190" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.invoiceCode">{{ row.invoiceCode }}</span>
              <span v-else class="tdi-text-muted">—</span>
            </template>
          </el-table-column >

          <el-table-column v-if="visibleColumns.additionalInfo" label="Thông tin bổ sung" width="130" align="center">
            <template slot-scope="{ row }">
              <el-tooltip content="Xem thông tin bổ sung" placement="top">
                <el-button
                  type="text"
                  icon="el-icon-notebook-2"
                  class="tdi-additional-info-btn"
                  @click="handleOpenAdditionalInfo(row)"
                />
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.unpaidInvoices" label="Phiếu thu chưa thanh toán" prop="quantityStock" width="130" align="center">
            <template slot-scope="{ row }">
              <span
                v-if="row.quantityStock > 0"
                class="tdi-unpaid-badge"
                @click="handleOpenUnpaidDialog(row)"
              >
                {{ row.quantityStock }}
              </span>
              <span v-else class="tdi-unpaid-badge">0</span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.releasedInvoices" label="Phiếu thu đã phát hành" prop="quantityStock" width="130" align="center">
            <template slot-scope="{ row }">
              <span
                  v-if="row.totalInvoiceCount > 0"
                  class="tdi-unpaid-badge"
                  @click="handleOpenHistoryDialog(row)"
              >
                {{ row.totalInvoiceCount }}
              </span>
              <span v-else class="tdi-unpaid-badge">0</span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.onlinePaymentStatus" label="Trạng thái TT thanh toán" align="center" width="180">
            <template slot-scope="{ row }">
              <i v-if="row.onlinePaymentStatus" class="el-icon-check" style="color: #22c55e; font-weight: bold; font-size: 16px;" />
              <i v-else class="el-icon-close" style="color: #ef4444; font-weight: bold; font-size: 16px;" />
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.status" label="Trạng thái" align="center" width="140">
            <template slot-scope="{ row }">
              <el-tag :type="statusTagType(row.status)" size="mini" effect="light">
                {{ statusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.turn" label="Đợt" prop="turn" width="60" align="center" />
          <el-table-column v-if="visibleColumns.monthYear" label="Tháng-Năm" width="100" align="center">
            <template slot-scope="{ row }">
              {{ row.month }}/{{ row.year }}
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.beforeMoney" label="Thiếu/Thừa phiếu thu trước" prop="beforeMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span :class="row.beforeMoney > 0 ? 'tdi-money--positive' : 'tdi-money--negative'">
                {{ row.beforeMoney | formatCurrency }}
              </span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.sumMoney" label="Phải thu" prop="sumMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money tdi-money--bold">{{ row.sumMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.collectedMoney" label="Đã thu" prop="collectedMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                class="tdi-fee-amount"
                @click="handleEditCollectedMoney(row)"
              >
                <span v-if="row.collectedMoney" class="tdi-money">{{ row.collectedMoney | formatCurrency }}</span>
                <span v-else class="tdi-money tdi-text-muted">-</span>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.cashMoney" label="Tiền mặt" prop="cashMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money">{{ row.cashMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.transferMoney" label="Chuyển khoản" prop="transferMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money">{{ row.transferMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="visibleColumns.afterMoney" label="Thiếu/Thừa còn lại" prop="afterMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">

              <span :class="row.afterMoney > 0 ? 'tdi-money--positive' : 'tdi-money--negative' ">
                {{ row.afterMoney | formatCurrency }}
              </span>
            </template>
          </el-table-column>
          <template v-if="visibleColumns.feeColumns">
            <el-table-column
              v-for="(item) in feeColumns"
              :key="item.prop"
              align="right"
              width="140"
              :label="item.label"
              :prop="item.prop"
              class-name="tdi-fee-column"
              :label-class-name="canManageFeeColumns ? 'tdi-fee-header is-clickable-header' : 'tdi-fee-header is-not-clickable'"
            >
              <template slot="header" slot-scope="scope">
                <el-tooltip :content="scope.column.label" placement="top">
                  <span
                    class="tdi-fee-header-text"
                    :class="{ 'is-clickable': canManageFeeColumns }"
                    @click.stop="canManageFeeColumns && handleFeeHeaderClick(item)"
                  >
                    {{ scope.column.label }}
                  </span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                <el-button
                  :disabled="checkPermission(['tuition_payment_v4']) === false"
                  type="text"
                  class="tdi-fee-amount"
                  @click="handleEditRevenueDetail(row, item)"
                >
                  <span v-if="hasFeeAmount(row[item.prop])" class="tdi-money tdi-money--fee">
                    {{ row[item.prop] | formatCurrency }}
                  </span>
                  <span v-else class="tdi-money tdi-money--fee">-</span>
                </el-button>
              </template>
            </el-table-column>
          </template>

          <el-table-column label="Tác vụ" width="160" align="center" fixed="right">
            <template slot-scope="{ row }">
              <div class="tdi-action-buttons">
                <el-tooltip content="Thanh toán" placement="top" :enterable="false">
                  <el-button
                    v-if="checkPermission(['tuition_payment_v4'])"
                    size="mini"
                    type="primary"
                    icon="el-icon-wallet"
                    circle
                    @click="handlePayment(row)"
                  />
                </el-tooltip>
                <el-tooltip content="Lịch sử thao tác" placement="top" :enterable="false">
                  <el-button
                    size="mini"
                    type="warning"
                    icon="el-icon-time"
                    circle
                    @click="handleActionHistory(row)"
                  />
                </el-tooltip>
                <el-tooltip content="Lịch sử thanh toán" placement="top" :enterable="false">
                  <el-button
                    size="mini"
                    type="success"
                    icon="el-icon-tickets"
                    circle
                    @click="handlePaymentHistory(row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="tdi-action-row" style="margin-top: 16px; justify-content: flex-end;">
        <el-dropdown
          v-if="checkPermission(['tuition_fees_services_action_v4'])"
          trigger="click"
          placement="top-end"
          @command="handleBatchCommand"
        >
          <el-button type="primary" class="tdi-batch-action-btn">
            <i class="el-icon-s-operation" style="margin-right: 6px;"></i>
            Tác vụ hàng loạt
            <i class="el-icon-arrow-up" style="margin-left: 6px; font-size: 11px;"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" class="tdi-batch-dropdown">
            <el-dropdown
              placement="left-start"
              :popper-options="{ modifiers: { flip: { enabled: false } } }"
              @command="handleBatchCommand"
              style="display: block;"
            >
              <el-dropdown-item class="tdi-nested-menu-item">
                <div class="tdi-nested-menu-label"><i class="el-icon-printer" style="margin-right: 6px;"></i>In phiếu thu</div>
                <i class="el-icon-arrow-left"></i>
              </el-dropdown-item>
              <el-dropdown-menu slot="dropdown" class="tdi-batch-dropdown">
                <el-dropdown-item command="print_1" icon="el-icon-printer">
                  In phiếu thu 1 liên
                </el-dropdown-item>
                <el-dropdown-item command="print_2" icon="el-icon-printer">
                  In phiếu thu 2 liên
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              v-if="checkPermission(['tuition_excel_export_v4'])"
              placement="left-start"
              :popper-options="{ modifiers: { flip: { enabled: false } } }"
              @command="handleBatchCommand"
              style="display: block;"
            >
              <el-dropdown-item class="tdi-nested-menu-item" >
                <div class="tdi-nested-menu-label"><i class="el-icon-download" style="margin-right: 6px;"></i>Xuất excel</div>
                <i class="el-icon-arrow-left"></i>
              </el-dropdown-item>
              <el-dropdown-menu slot="dropdown" class="tdi-batch-dropdown">
                <el-dropdown-item command="export_excel_selected" icon="el-icon-document-checked">
                  Theo phiếu thu
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown-item
              v-if="!isPackageMode && checkPermission(['tuition_v4_import_excel'])"
              command="import_excel"
              icon="el-icon-upload2"
            >
              Nhập từ Excel
            </el-dropdown-item>
            <el-dropdown-item
              v-if="!isPackageMode && checkPermission(['tuition_v4_rename_add_delete'])"
              command="add_batch_revenue"
              icon="el-icon-circle-plus-outline"
            >
              Thêm khoản thu
            </el-dropdown-item>
            <el-dropdown-item
              v-if="!isPackageMode && checkPermission(['tuition_fees_services_action_v4'])"
              command="init_student_invoice"
              icon="el-icon-document-add"
            >
              Khởi tạo khoản thu
            </el-dropdown-item>
            <el-dropdown
              placement="left-start"
              :popper-options="{ modifiers: { flip: { enabled: false } } }"
              @command="handleBatchCommand"
              style="display: block;"
            >
              <el-dropdown-item class="tdi-nested-menu-item">
                <div class="tdi-nested-menu-label"><i class="el-icon-s-promotion" style="margin-right: 6px;"></i>Gửi học phí</div>
                <i class="el-icon-arrow-left"></i>
              </el-dropdown-item>
              <el-dropdown-menu slot="dropdown" class="tdi-batch-dropdown">
                <el-dropdown-item command="send_onekids" icon="el-icon-mobile-phone">
                  Gửi qua Onekids
                </el-dropdown-item>
                <el-dropdown-item command="send_sms" icon="el-icon-chat-round">
                  Gửi qua SMS
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              placement="left-start"
              :popper-options="{ modifiers: { flip: { enabled: false } } }"
              @command="handleBatchCommand"
              style="display: block;"
            >
              <el-dropdown-item class="tdi-nested-menu-item">
                <div class="tdi-nested-menu-label"><i class="el-icon-document" style="margin-right: 6px;"></i>Xử lý phiếu thu</div>
                <i class="el-icon-arrow-left"></i>
              </el-dropdown-item>
              <el-dropdown-menu slot="dropdown" class="tdi-batch-dropdown">
                <el-dropdown-item command="hide" icon="el-icon-turn-off">
                  Bỏ hiển  phiếu thu
                </el-dropdown-item>
                <el-dropdown-item command="show" icon="el-icon-view">
                  Hiển thị phiếu thu
                </el-dropdown-item>
                <el-dropdown-item v-if="canBatchCancel" command="cancel" icon="el-icon-circle-close">
                  Huỷ phiếu thu
                </el-dropdown-item>
                <el-dropdown-item v-if="canBatchRestore" command="restore" icon="el-icon-refresh-left">
                  Khôi phục phiếu thu
                </el-dropdown-item>
                <el-dropdown-item v-if="canBatchDelete" command="delete" icon="el-icon-delete">
                  Xoá phiếu thu
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown-item
              v-if="checkPermission(['electronic-invoice-create-draft'])"
              command="createManyDraft"
              icon="el-icon-document-add"
            >
              Tạo nhiều HĐ nháp
            </el-dropdown-item>
            <el-dropdown-item command="registerBank" icon="el-icon-bank-card">
              Chọn TK thanh toán trực tuyến
            </el-dropdown-item>
            <el-dropdown-item command="sync_attendance" icon="el-icon-bank-card">
              Đồng bộ dữ liệu điểm danh
            </el-dropdown-item>
            <el-dropdown-item command="batch_pay" icon="el-icon-wallet" v-if="checkPermission(['tuition_payment_v4'])">
              Thanh toán hàng loạt
            </el-dropdown-item>
            <el-dropdown-item command="note" icon="el-icon-edit-outline">
              Tạo ghi chú
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="tdi-notes-section">
        <p class="tdi-notes-title"><i class="el-icon-info"></i> Ghi chú về tác vụ xử lý phiếu thu:</p>
        <ul class="tdi-notes-list">
          <li><strong>Huỷ phiếu thu:</strong> Chỉ áp dụng khi tất cả phiếu thu được chọn đã phát hành, không ở trạng thái <em>Ẩn</em> và đang ở chế độ <em>Hiển thị</em>.</li>
          <li><strong>Khôi phục phiếu thu:</strong> Chỉ áp dụng khi tất cả phiếu thu được chọn đang ở trạng thái <em>Ẩn</em>.</li>
          <li><strong>Xoá phiếu thu:</strong> Chỉ áp dụng khi tất cả phiếu thu được chọn đang ở trạng thái <em>Ẩn</em>. Hành động này không thể hoàn tác.</li>
        </ul>
      </div>
    </div>

    <!-- DIALOG PHIẾU THU CHƯA THANH TOÁN -->
    <unpaid-invoices-dialog
      ref="unpaidInvoicesDialog"
      @payment="handlePayment"
    />

    <!-- DIALOG LỊCH SỬ PHIẾU THU HỌC SINH -->
    <student-invoice-history-dialog
      ref="studentInvoiceHistoryDialog"
      @payment="handlePayment"
      @saved="handleSearch"
    />

    <!-- DIALOG LỊCH SỬ THAO TÁC (AUDIT TRAIL) -->
    <invoice-action-history-dialog
      ref="invoiceActionHistoryDialog"
    />

    <!-- DIALOG LỊCH SỬ THANH TOÁN PHIẾU THU -->
    <invoice-payment-history-dialog
      ref="invoicePaymentHistoryDialog"
    />

    <!-- DIALOG ĐIỀU CHỈNH TIỀN ĐÃ THU -->
    <adjust-collected-money-dialog
      ref="adjustCollectedMoneyDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG THÔNG TIN BỔ SUNG -->
    <additional-info-dialog
      ref="additionalInfoDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG CHỈNH SỬA KHOẢN THU PHIẾU THU -->
    <edit-invoice-detail-item-dialog
      ref="editInvoiceDetailItemDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG THANH TOÁN PHIẾU THU -->
    <invoice-payment-dialog
      ref="invoicePaymentDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG TẠO GHI CHÚ HÀNG LOẠT -->
    <batch-update-note-dialog
      ref="batchUpdateNoteDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG CHỌN TK THANH TOÁN TRỰC TUYẾN -->
    <register-bank-for-order-dialog
      ref="registerBankForOrderDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG GỬI THÔNG BÁO QUA APP -->
    <send-app-invoice-dialog
      ref="sendAppInvoiceDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG THANH TOÁN HÀNG LOẠT -->
    <batch-payment-dialog
      ref="batchPaymentDialog"
      @saved="handleSearch"
    />

    <!-- DIALOG TẠO NHIỀU HÓA ĐƠN NHÁP -->
    <InvoiceCreateManyDialog
      :isOpenInvoiceCreateDialog="isOpenInvoiceCreateManyDialog"
      :kidCodes="selectedKidCodes"
      @dialog-close="closeInvoiceCreateManyDialog"
    />

    <!-- DIALOG KHỞI TẠO PHIẾU THU TỪ EXCEL (WIZARD 3 BƯỚC) -->
    <invoice-excel-import-wizard-dialog
      ref="invoiceExcelImportWizardDialog"
      :grade-list="gradeOfSchoolList"
      :class-list="classList"
      :kid-group-list="kidGroupList"
      :package-list="packageList"
      @imported-success="handleImportedSuccess"
      @dialog-close="handleImportWizardClose"
      @imported-mock-data="handleImportedMockData"
    />

    <!-- DIALOG THAO TÁC KHOẢN THU (ĐỔI TÊN / XÓA) -->
    <RenameFeeDialog
      ref="renameFeeDialog"
      @saved="handleFeeRenamed"
      @deleted="handleFeeDeleted"
      @refresh="handleSearch"
    />

    <!-- DIALOG THÊM KHOẢN THU HÀNG LOẠT -->
    <AddBatchRevenueDialog
      ref="addBatchRevenueDialog"
      @saved="handleBatchRevenueAdded"
      @refresh="handleSearch"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import GroupExcelService from "@/services/Finance_Kids_V2/GroupExcelService";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import { exportSelectedStudentsExcel } from "@/commonFuncion/exportTuitionStudentListExcel";
import { kidStatusList } from "@/constant/listCommon";
import UnpaidInvoicesDialog from "@/components/tutition_v3/dialog/UnpaidInvoicesDialog.vue";
import StudentInvoiceHistoryDialog from "@/components/tutition_v3/dialog/StudentInvoiceHistoryDialog.vue";
import InvoicePaymentHistoryDialog from "@/components/tutition_v3/dialog/InvoicePaymentHistoryDialog.vue";
import AdjustCollectedMoneyDialog from "@/components/tutition_v3/dialog/AdjustCollectedMoneyDialog.vue";
import AdditionalInfoDialog from "@/components/tutition_v3/dialog/AdditionalInfoDialog.vue";
import EditInvoiceDetailItemDialog from "@/components/tutition_v3/dialog/EditInvoiceDetailItemDialog.vue";
import InvoicePaymentDialog from "@/components/tutition_v3/dialog/InvoicePaymentDialog.vue";
import BatchUpdateNoteDialog from "@/components/tutition_v3/dialog/BatchUpdateNoteDialog.vue";
import RegisterBankForOrderDialog from "@/components/tutition_v3/dialog/RegisterBankForOrderDialog.vue";
import SendAppInvoiceDialog from "@/components/tutition_v3/dialog/SendAppInvoiceDialog.vue";
import BatchPaymentDialog from "@/components/tutition_v3/dialog/BatchPaymentDialog.vue";
import InvoiceActionHistoryDialog from "@/components/tutition_v3/dialog/InvoiceActionHistoryDialog.vue";
import InvoiceCreateManyDialog from "@/components/sinvoice_viettel/dialog/InvoiceCreateManyDialog.vue";
import InvoiceExcelImportWizardDialog from "@/components/tutition_v3/dialog/InvoiceExcelImportWizardDialog.vue";
import RenameFeeDialog from "@/components/tutition_v3/dialog/RenameFeeDialog.vue";
import AddBatchRevenueDialog from "@/components/tutition_v3/dialog/AddBatchRevenueDialog.vue";
import SinvoiceViettelService from "@/services/SinvoiceViettelService";
import PackageManagementService from "@/services/tutition_v3/PackageManagementService";
import checkPermission from "@/utils/permission";

const STATUS_OPTIONS = [
  { value: "UNBILLED", label: "Chưa có phiếu thu" },
  { value: "UNPAID", label: "Chưa đóng 100%" },
  { value: "PARTIALLY_PAID", label: "Chưa đóng đủ" },
  { value: "FULLY_PAID", label: "Đóng đủ 100%" },
  { value: "OVERPAID", label: "Đóng thừa" },
  { value: "FULLY_PAID_WITH_SURPLUS", label: "Đóng đủ thừa" },
  { value: "PAID_WITH_DEFICIT", label: "Đóng đủ thiếu" },
  { value: "HIDE", label: "Ẩn phiếu thu" },
];

export default {
  name: "ManagingStudentInvoice",
  components: { UnpaidInvoicesDialog, StudentInvoiceHistoryDialog, InvoicePaymentHistoryDialog, AdjustCollectedMoneyDialog, AdditionalInfoDialog, EditInvoiceDetailItemDialog, InvoicePaymentDialog, BatchUpdateNoteDialog, RegisterBankForOrderDialog, SendAppInvoiceDialog, BatchPaymentDialog, InvoiceActionHistoryDialog, InvoiceCreateManyDialog, InvoiceExcelImportWizardDialog, RenameFeeDialog, AddBatchRevenueDialog },

  data() {
    return {
      collectionTurns: [],
      statusOptions: STATUS_OPTIONS,
      kidStatusList,
      isLoading: false,
      emptyText: "Vui lòng nhập điều kiện và bấm tìm kiếm.",
      tableData: [],
      totalRecord: 0,
      kidGroupList: [],
      packageList: [],
      feeColumns: [],
      isDeletingFee: false,
      visibleColumns: {
        nickName: true,
        className: true,
        hideReceipt: true,
        parentUnread: true,
        invoiceCode: true,
        additionalInfo: true,
        unpaidInvoices: true,
        releasedInvoices: true,
        onlinePaymentStatus: true,
        status: true,
        turn: true,
        monthYear: true,
        beforeMoney: true,
        sumMoney: true,
        collectedMoney: true,
        cashMoney: true,
        transferMoney: true,
        afterMoney: true,
        feeColumns: true,
      },
      searchRequest: {
        targetType: "CLASS",
        // Tháng đơn (CLASS / GROUP)
        monthAndYear: moment().format("M-yyyy"),
        month: moment().month() + 1,
        year: moment().year(),
        // Khoảng tháng (PACKAGE)
        fromMonthAndYear: moment().format("M-yyyy"),
        fromMonth: moment().month() + 1,
        fromYear: moment().year(),
        toMonthAndYear: moment().format("M-yyyy"),
        toMonth: moment().month() + 1,
        toYear: moment().year(),
        idGrade: "",
        idClass: "",
        idGroup: "",
        idPackage: "",
        status: null,
        kidStatus: "STUDYING",
        turn: null,
        name: "",
      },
      searchRules: {
        targetType: [{ required: true, message: "Vui lòng chọn phạm vi", trigger: "change" }],
        monthAndYear: [{
          validator: (rule, value, callback) => {
            if (!this.isPackageMode && !value) {
              callback(new Error("Vui lòng chọn tháng"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
        fromMonthAndYear: [{
          validator: (rule, value, callback) => {
            if (this.isPackageMode && !value) {
              callback(new Error("Vui lòng chọn tháng bắt đầu"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
        toMonthAndYear: [{
          validator: (rule, value, callback) => {
            if (this.isPackageMode && !value) {
              callback(new Error("Vui lòng chọn tháng kết thúc"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
        idClass: [{
          validator: (rule, value, callback) => {
            if (this.isClassMode && !value) {
              callback(new Error("Vui lòng chọn lớp"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
        idGroup: [{
          validator: (rule, value, callback) => {
            if (this.isGroupMode && !value) {
              callback(new Error("Vui lòng chọn nhóm"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
        idPackage: [{
          validator: (rule, value, callback) => {
            if (this.isPackageMode && !value) {
              callback(new Error("Vui lòng chọn gói dịch vụ"));
              return;
            }
            callback();
          },
          trigger: "change",
        }],
      },
      isRestoringState: false,
      isReloadingAllData: false,
      multipleSelection: [],
      // Dialog tạo nhiều hóa đơn nháp
      isOpenInvoiceCreateManyDialog: false,
      selectedKidCodes: [],
    };
  },

  computed: {
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
    ...mapState("classStore", ["classListCommon"]),

    schoolInfo() {
      return this.$store.getters['schoolStore/schoolInfo'] || [];
    },

    classList() {
      if (this.isPackageMode && !this.searchRequest.idGrade) return this.classListCommon;
      return this.classListCommon.filter((item) => item.idGrade === this.searchRequest.idGrade);
    },

    isClassMode() {
      return this.searchRequest.targetType === "CLASS";
    },

    isGroupMode() {
      return this.searchRequest.targetType === "GROUP";
    },

    isPackageMode() {
      return this.searchRequest.targetType === "PACKAGE";
    },

    canManageFeeColumns() {
      return !this.isPackageMode && this.checkPermission(['tuition_v4_rename_add_delete']);
    },

    // Hiển thị tác vụ Huỷ: tất cả phiếu thu đã chọn phải khác UNBILLED, khác HIDE, và hideReceipt = true
    canBatchCancel() {
      return this.multipleSelection.length > 0 && this.multipleSelection.every(
        (row) => row.status !== "UNBILLED" && row.status !== "HIDE" && row.hideReceipt === true
      );
    },

    // Hiển thị tác vụ Khôi phục: tất cả phiếu thu đã chọn phải ở trạng thái Ẩn (HIDE)
    canBatchRestore() {
      return this.multipleSelection.length > 0 && this.multipleSelection.every(
        (row) => row.status === "HIDE"
      );
    },

    // Hiển thị tác vụ Xoá: tất cả phiếu thu đã chọn phải ở trạng thái Ẩn (HIDE)
    canBatchDelete() {
      return this.multipleSelection.length > 0 && this.multipleSelection.every(
        (row) => row.status === "HIDE"
      );
    },
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true,
      handler(list) {
        if (this.isRestoringState || !this.isClassMode) return;
        if (Array.isArray(list) && list.length > 0 && !this.searchRequest.idGrade) {
          this.searchRequest.idGrade = list[0].id;
        }
      },
    },

    classList: {
      immediate: true,
      handler(list) {
        if (this.isRestoringState) return;
        if (this.isPackageMode) {
          if (this.searchRequest.idClass && !(list || []).some((item) => item.id === this.searchRequest.idClass)) {
            this.searchRequest.idClass = "";
          }
          return;
        }
        if (!this.isClassMode) return;
        if (!Array.isArray(list) || list.length === 0) {
          this.searchRequest.idClass = "";
          return;
        }
        const hasCurrentClass = list.some((item) => item.id === this.searchRequest.idClass);
        if (!hasCurrentClass) {
          this.searchRequest.idClass = list[0].id;
        }
      },
    },
  },

  async created() {
    this.restoreStateFromQuery();

    await this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
    await this.$store.dispatch("classStore/fetchDataClassListCommon");
    await this.$store.dispatch("schoolStore/fetchDataSchoolData", "");
    await this.fetchGroups();
    await this.fetchPackages();

    this.isRestoringState = false;

    if (this.checkPermission(['electronic-invoice-create-issued', 'electronic-invoice-create-draft'])) {
      if (!this.$store.state.sinvoiceCustomerConfigStore.hasData) {
        try {
          const response = await SinvoiceViettelService.getCustomerInformation();
          if (response.data && response.data.data) {
            let raw = response.data.data;
            if (Array.isArray(raw)) {
              raw = raw.length > 0 ? raw[0] : null;
            }
            if (raw) {
              await this.$store.dispatch("sinvoiceCustomerConfigStore/setFromApiData", raw);
            }
          }
        } catch (e) {
          console.warn("Failed to load customer configuration in ManagingStudentInvoice:", e);
        }
      }
    }

    await this.fetchMaxTurn();
    await this.handleSearch();
  },

  methods: {
    updateQueryToUrl() {
      const query = {
        targetType: this.searchRequest.targetType,
        monthAndYear: this.searchRequest.monthAndYear,
        fromMonthAndYear: this.searchRequest.fromMonthAndYear,
        toMonthAndYear: this.searchRequest.toMonthAndYear,
        kidStatus: this.searchRequest.kidStatus,
        idGrade: this.searchRequest.idGrade,
        idClass: this.searchRequest.idClass,
        idGroup: this.searchRequest.idGroup,
        idPackage: this.searchRequest.idPackage,
        status: this.searchRequest.status,
        turn: this.searchRequest.turn,
        name: this.searchRequest.name,
      };

      Object.keys(query).forEach((key) => {
        if (query[key] === null || query[key] === "" || query[key] === undefined) {
          delete query[key];
        }
      });

      this.$router.replace({ query }).catch(() => {});
    },

    restoreStateFromQuery() {
      const query = this.$route.query;
      if (Object.keys(query).length > 0) {
        this.isRestoringState = true;
        const restored = { ...this.searchRequest, ...query };
        // Hidden CLASS defaults must not become PACKAGE filters on a fresh route.
        if (restored.targetType === "PACKAGE") {
          if (!query.idGrade) restored.idGrade = "";
          if (!query.idClass) restored.idClass = "";
        }

        const numericFields = ["idGrade", "idClass", "idGroup", "idPackage", "turn"];
        numericFields.forEach(field => {
          if (restored[field] && !isNaN(restored[field])) {
            restored[field] = Number(restored[field]);
          }
        });

        this.searchRequest = restored;
        this.parseMonthAndYear();
        this.parsePackageDateRange();
      }
    },

    async fetchMaxTurn(forceReset = false) {
      const params = {
        idClass: this.searchRequest.idClass,
        idGroup: this.searchRequest.idGroup,
        idPackage: this.searchRequest.idPackage,
        targetType: this.searchRequest.targetType,
        month: this.searchRequest.month,
        year: this.searchRequest.year,
      };
      try {
        const response = await ManagingStudentInvoiceService.getMaxTurn(params);
        const maxTurn = response.data.data;
        this.collectionTurns = Array.from({ length: maxTurn }, (_, i) => i + 1);

        if (this.isRestoringState) {
          if (this.searchRequest.turn > maxTurn) {
            this.searchRequest.turn = maxTurn > 0 ? maxTurn : null;
          }
          return;
        }

        if (forceReset) {
          this.searchRequest.turn = maxTurn > 0 ? maxTurn : null;
          return;
        }

        if (!this.searchRequest.turn || this.searchRequest.turn > maxTurn) {
            this.searchRequest.turn = maxTurn > 0 ? maxTurn : null;
        }

      } catch (error) {
        console.error(error);
        this.collectionTurns = [];
        this.searchRequest.turn = null;
        NotifyMessage.leftCornerNotificationError("Không thể tải danh sách đợt thu.");
      }
    },

    statusLabel(status) {
      const item = STATUS_OPTIONS.find((option) => option.value === status);
      return item ? item.label : status || "-";
    },

    statusTagType(status) {
      const map = {
        UNBILLED: "info",
        UNPAID: "danger",
        PARTIALLY_PAID: "warning",
        FULLY_PAID: "success",
        OVERPAID: "success",
        FULLY_PAID_WITH_SURPLUS: "success",
        PAID_WITH_DEFICIT: "warning",
        HIDE: "warning",
      };
      return map[status] || "info";
    },

    parseMonthAndYear() {
      const [month, year] = (this.searchRequest.monthAndYear || "").split("-");
      this.searchRequest.month = Number(month);
      this.searchRequest.year = Number(year);
    },

    parsePackageDateRange() {
      const [fromMonth, fromYear] = (this.searchRequest.fromMonthAndYear || "").split("-");
      this.searchRequest.fromMonth = Number(fromMonth);
      this.searchRequest.fromYear = Number(fromYear);

      const [toMonth, toYear] = (this.searchRequest.toMonthAndYear || "").split("-");
      this.searchRequest.toMonth = Number(toMonth);
      this.searchRequest.toYear = Number(toYear);
    },

    async handlePackageDateChange() {
      this.parsePackageDateRange();
      await this.handleSearch();
    },

    async handleMonthChange() {
      this.parseMonthAndYear();
      await this.fetchMaxTurn(true);
      await this.handleSearch();
    },

    isFilterActive(fieldName) {
      if (fieldName === "monthAndYear") {
        return this.searchRequest.monthAndYear !== moment().format("M-yyyy");
      }
      if (fieldName === "kidStatus") {
        return this.searchRequest.kidStatus !== "STUDYING";
      }
      if (fieldName === "status") {
        return this.searchRequest.status !== null && this.searchRequest.status !== "";
      }
      if (fieldName === "name") {
        return this.searchRequest.name !== "";
      }
      if (fieldName === "turn") {
        return this.searchRequest.turn !== null;
      }
      return false;
    },

    async handleResetFilters() {
      // Clear URL query
      this.$router.replace({ query: {} }).catch(() => {});

      // Reset values to defaults
      this.searchRequest.targetType = "CLASS";
      this.searchRequest.monthAndYear = moment().format("M-yyyy");
      this.searchRequest.month = moment().month() + 1;
      this.searchRequest.year = moment().year();

      if (Array.isArray(this.gradeOfSchoolList) && this.gradeOfSchoolList.length > 0) {
        this.searchRequest.idGrade = this.gradeOfSchoolList[0].id;
      } else {
        this.searchRequest.idGrade = "";
      }

      this.searchRequest.idClass = "";
      this.searchRequest.idGroup = "";
      this.searchRequest.idPackage = "";
      this.searchRequest.fromMonthAndYear = moment().format("M-yyyy");
      this.searchRequest.fromMonth = moment().month() + 1;
      this.searchRequest.fromYear = moment().year();
      this.searchRequest.toMonthAndYear = moment().format("M-yyyy");
      this.searchRequest.toMonth = moment().month() + 1;
      this.searchRequest.toYear = moment().year();
      this.searchRequest.status = null;
      this.searchRequest.kidStatus = "STUDYING";
      this.searchRequest.turn = null;
      this.searchRequest.name = "";

      // Re-trigger defaults & search
      await this.fetchMaxTurn(true);
      await this.handleSearch();
    },

    async handleTargetTypeChange() {
      this.tableData = [];
      this.totalRecord = 0;

      if (this.isClassMode) {
        if (!this.searchRequest.idGrade && this.gradeOfSchoolList.length > 0) {
          this.searchRequest.idGrade = this.gradeOfSchoolList[0].id;
        }
        this.searchRequest.idGroup = "";
        this.searchRequest.idPackage = "";
        this.searchRequest.idClass = this.classList.length > 0 ? this.classList[0].id : "";
      } else if (this.isGroupMode) {
        this.searchRequest.idClass = "";
        this.searchRequest.idPackage = "";
        this.searchRequest.idGroup = this.kidGroupList.length > 0 ? this.kidGroupList[0].id : "";
      } else if (this.isPackageMode) {
        this.searchRequest.idGrade = "";
        this.searchRequest.idClass = "";
        this.searchRequest.idGroup = "";
        this.searchRequest.idPackage = this.packageList.length > 0 ? this.packageList[0].id : "";
      }

      this.$refs.searchFormRef && this.$refs.searchFormRef.clearValidate();
      await this.fetchMaxTurn(true);
      await this.handleSearch();
    },

    async handleGradeChange() {
      if (this.isPackageMode) {
        this.searchRequest.idClass = "";
        await this.handleSearch();
        return;
      }
      this.searchRequest.idClass = this.classList.length > 0 ? this.classList[0].id : "";
      await this.fetchMaxTurn(true);
      await this.handleSearch();
    },

    async fetchGroups() {
      try {
        const response = await GroupExcelService.getListKidsGroup();
        this.kidGroupList = Array.isArray(response?.data) ? response.data : [];
        if (!this.isRestoringState && this.isGroupMode && this.kidGroupList.length > 0) {
          const hasCurrentGroup = this.kidGroupList.some((g) => g.id === this.searchRequest.idGroup);
          if (!hasCurrentGroup) {
            this.searchRequest.idGroup = this.kidGroupList[0].id;
          }
        }
      } catch (error) {
        this.kidGroupList = [];
        NotifyMessage.leftCornerNotificationError("Không thể tải danh sách nhóm.");
      }
    },

    async fetchPackages() {
      try {
        const res = await PackageManagementService.getAll();
        this.packageList = res.data.data || [];
        if (!this.isRestoringState && this.isPackageMode && this.packageList.length > 0) {
          const hasCurrentPkg = this.packageList.some((p) => p.id === this.searchRequest.idPackage);
          if (!hasCurrentPkg) {
            this.searchRequest.idPackage = this.packageList[0].id;
          }
        }
      } catch (err) {
        this.packageList = [];
        console.error(err);
      }
    },

    buildPayload() {
      const base = {
        targetType: this.searchRequest.targetType,
        idClass: (this.isClassMode || this.isPackageMode) ? (this.searchRequest.idClass || null) : null,
        idGroup: this.isGroupMode ? this.searchRequest.idGroup : null,
        idPackage: this.isPackageMode ? this.searchRequest.idPackage : null,
        status: this.searchRequest.status || null,
        kidStatus: this.searchRequest.kidStatus || null,
        turn: this.searchRequest.turn || null,
        name: this.searchRequest.name ? this.searchRequest.name.trim() : null,
      };

      if (this.isPackageMode) {
        // Khối/lớp hiện tại là bộ lọc tùy chọn; null tương ứng Tất cả.
        base.idGrade = this.searchRequest.idGrade || null;
        // Chế độ gói: truyền khoảng tháng thay vì tháng đơn
        base.fromMonth = this.searchRequest.fromMonth || null;
        base.fromYear = this.searchRequest.fromYear || null;
        base.toMonth = this.searchRequest.toMonth || null;
        base.toYear = this.searchRequest.toYear || null;
      } else {
        base.month = this.searchRequest.month || null;
        base.year = this.searchRequest.year || null;
      }

      return base;
    },

    normalizeInvoiceList(dataList) {
      return (Array.isArray(dataList) ? dataList : []).map((item) => ({
        ...item,
        studentCode: item.studentCode || "",
        fullName: item.fullName || "",
        className: item.className || "",
        turn: item.turn || "-",
        invoiceCode: item.invoiceCode || "-",
        status: item.status || "UNBILLED",
        beforeMoney: Number(item.beforeMoney || 0),
        sumMoney: Number(item.sumMoney || 0),
        collectedMoney: Number(item.collectedMoney || 0),
        cashMoney: Number(item.cashMoney || 0),
        transferMoney: Number(item.transferMoney || 0),
        afterMoney: Number(item.afterMoney || 0),
        invoiceDetails: Array.isArray(item.invoiceDetails) ? item.invoiceDetails : [],
        hideReceipt: item.hideReceipt || false, // Default to false if not provided
        parentUnread: item.parentUnread || false, // Default to false if not provided
        onlinePaymentStatus: !!item.onlinePaymentStatus,
      }));
    },

    async handleSearch() {
      const valid = await this.$refs.searchFormRef.validate().catch(() => false);
      if (!valid) return;

      this.updateQueryToUrl();
      this.parseMonthAndYear();
      this.isLoading = true;
      this.emptyText = "Đang tải dữ liệu...";

      try {
        const payload = this.buildPayload();
        const response = await ManagingStudentInvoiceService.searchInvoices(payload);
        const responseData = response?.data || {};

        const rawInvoices = this.normalizeInvoiceList(responseData.data || []);
        this.feeColumns = this.normalizeFeeColumns(rawInvoices);
        const dataList = rawInvoices.map((item) => this.normalizeInvoiceRow(item, this.feeColumns));

        this.tableData = dataList;
        this.totalRecord = Number(responseData.total || dataList.length || 0);
        this.emptyText = dataList.length > 0 ? "" : "Không có phiếu thu phù hợp.";
      } catch (error) {
        console.error(error);
        this.tableData = [];
        this.totalRecord = 0;
        this.emptyText = "Không có dữ liệu.";
      } finally {
        this.isLoading = false;
      }
    },

    getSummaries({ columns, data }) {
      const sumProps = new Set([
        "beforeMoney",
        "sumMoney",
        "collectedMoney",
        "cashMoney",
        "transferMoney",
        "afterMoney",
        ...this.feeColumns.map((item) => item.prop),
      ]);
      const sums = [];
      columns.forEach((col, idx) => {
        if (idx === 2) { // Assuming index 2 is the 'Họ tên' column after STT and Selection
          sums[idx] = "Tổng cộng";
          return;
        }
        if (!sumProps.has(col.property)) {
          sums[idx] = "";
          return;
        }
        const vals = data.map((row) => Number(row[col.property]));
        if (!vals.every(isNaN)) {
          sums[idx] = vals
            .reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0)
            .toLocaleString("vi-VN", { style: "currency", currency: "VND" });
        } else {
          sums[idx] = "";
        }
      });
      return sums;
    },

    normalizeFeeColumns(invoiceList) {
      if (!Array.isArray(invoiceList) || invoiceList.length === 0) {
        return [];
      }

      // Collect all unique revenueCode entries across all invoices, preserving first-seen order
      const revenueMap = new Map(); // revenueCode -> info object
      for (const invoice of invoiceList) {
        if (!Array.isArray(invoice.invoiceDetails)) continue;
        for (const detail of invoice.invoiceDetails) {
          if (detail.revenueCode && !revenueMap.has(detail.revenueCode)) {
            revenueMap.set(detail.revenueCode, {
              revenueCode: String(detail.revenueCode).trim(), // Mã khoản thu (revenueCode)
              idx: detail.idx ? String(detail.idx).trim() : '', // Mã định danh hệ thống (idx)
              revenueName: detail.revenueName || '',
              unit: detail.unit || 'Tháng',
              price: Number(detail.price || 0),
            });
          }
        }
      }

      if (revenueMap.size === 0) {
        return [];
      }

      const columns = [];
      let index = 0;
      for (const [revenueCode, info] of revenueMap) {
        columns.push({
          key: revenueCode,
          revenueCode: info.revenueCode, // Mã khoản thu
          idx: info.idx, // Mã định danh
          unit: info.unit,
          price: info.price,
          prop: `moneyKt${index + 1}`,
          label: info.revenueName || `Khoản thu ${index + 1}`,
        });
        index++;
      }
      return columns;
    },

    normalizeInvoiceRow(invoice, columns) {
      const normalized = {
        ...invoice,
        hideReceipt: invoice.hideReceipt || false, // Ensure hideReceipt is present
        parentUnread: invoice.parentUnread || false, // Ensure parentUnread is present
      };

      // Build a lookup map from revenueCode -> detail for this invoice
      const detailMap = new Map();
      if (Array.isArray(invoice.invoiceDetails)) {
        for (const detail of invoice.invoiceDetails) {
          if (detail.revenueCode) {
            detailMap.set(detail.revenueCode, detail);
          }
        }
      }

      (Array.isArray(columns) ? columns : []).forEach((col) => {
        const detail = detailMap.get(col.key);
        normalized[col.prop] = detail ? (Number(detail.amount) || 0) : 0;
      });
      return normalized;
    },

    hasFeeAmount(value) {
      if (value === null || value === undefined) return false;
      const amount = Number(value);
      return !Number.isNaN(amount) && amount !== 0;
    },

    handleOpenAdditionalInfo(row) {
      this.$refs.additionalInfoDialog.open(row);
    },

    handleEditCollectedMoney(row) {
      this.$refs.adjustCollectedMoneyDialog.open(row);
    },

    handleEditRevenueDetail(row, feeColumn) {
      const detail = (row.invoiceDetails || []).find(d => d.revenueCode === feeColumn.key);
      if (!detail || !detail.idx) {
        NotifyMessage.leftCornerNotificationError("Không tìm thấy thông tin khoản thu.");
        return;
      }
      this.$refs.editInvoiceDetailItemDialog.open(row.idx, detail.idx, detail);
    },

    getFeeActionContext() {
      if (this.isPackageMode) return null;
      const [month, year] = (this.searchRequest.monthAndYear || "").split("-");
      const turn = Number(this.searchRequest.turn);
      if (!Number.isInteger(turn) || turn < 1) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn đợt thu trước khi thao tác khoản thu.");
        return null;
      }
      const targetId = this.isClassMode ? this.searchRequest.idClass : this.searchRequest.idGroup;
      const selectedMonth = Number(month || this.searchRequest.month);
      const selectedYear = Number(year || this.searchRequest.year);
      if (!Number(targetId) || !selectedMonth || !selectedYear) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn lớp/nhóm và tháng thu.");
        return null;
      }
      const currentClass = (this.classList || []).find((c) => c.id === this.searchRequest.idClass);
      const currentGroup = (this.kidGroupList || []).find((g) => g.id === this.searchRequest.idGroup);
      return {
        targetId: Number(targetId),
        targetType: this.searchRequest.targetType,
        targetName: this.isClassMode ? (currentClass?.className || "") : (currentGroup?.groupName || ""),
        month: selectedMonth,
        year: selectedYear,
        turn,
      };
    },

    handleFeeHeaderClick(feeColumn) {
      if (!this.canManageFeeColumns) return;
      this.handleOpenRenameFeeDialog(feeColumn);
    },

    handleTableHeaderClick(column) {
      if (!this.canManageFeeColumns) return;
      const col = (this.feeColumns || []).find((c) => c.prop === column.property);
      if (col) {
        this.handleOpenRenameFeeDialog(col);
      }
    },

    handleFeeCommand(command, feeColumn) {
      if (!this.canManageFeeColumns) return;
      if (command === "delete") {
        this.handleOpenRenameFeeDialog(feeColumn, "delete");
      } else {
        this.handleOpenRenameFeeDialog(feeColumn, "rename");
      }
    },

    handleOpenRenameFeeDialog(feeColumn, defaultAction = "rename") {
      if (!feeColumn || !this.canManageFeeColumns) return;
      const context = this.getFeeActionContext();
      if (context) this.$refs.renameFeeDialog.open(feeColumn, context, defaultAction);
    },

    async handleDeleteFee(feeColumn) {
      if (!feeColumn?.revenueCode || this.isDeletingFee || !this.canManageFeeColumns) return;
      const context = this.getFeeActionContext();
      if (!context) return;
      try {
        await this.$confirm(
          `Xóa khoản "${feeColumn.label}" (mã ${feeColumn.revenueCode}) khỏi tất cả phiếu thu của ${context.targetName || 'lớp/nhóm đã chọn'}, tháng ${context.month}/${context.year}, đợt ${context.turn}? Tổng tiền và số dư của phiếu có khoản này sẽ được cập nhật.`,
          "Xóa khoản thu",
          { confirmButtonText: "Xóa khoản thu", cancelButtonText: "Hủy", type: "warning", closeOnClickModal: false }
        );
      } catch (_) {
        return;
      }
      this.isDeletingFee = true;
      try {
        const response = await ManagingStudentInvoiceService.deleteFee({
          targetType: context.targetType, targetId: context.targetId,
          month: context.month, year: context.year, turn: context.turn,
          revenueCode: feeColumn.revenueCode,
        });
        const result = response?.data?.data;
        if (!result || typeof result.updatedInvoiceCount !== "number") throw new Error("API xóa khoản thu không trả kết quả hợp lệ.");
        await this.handleSearch();
        NotifyMessage.leftCornerNotificationSuccess(`Đã xóa khoản "${feeColumn.label}" trên ${result.updatedInvoiceCount} phiếu thu.`);
        if (result.auditFailedCount > 0) NotifyMessage.leftCornerNotificationWarning(`${result.auditFailedCount} phiếu chưa ghi được lịch sử thao tác.`);
      } catch (error) {
        let errorData = error?.response?.data;
        if (typeof errorData === "string") {
          try { errorData = JSON.parse(errorData); } catch (_) { /* Giữ thông báo gốc. */ }
        }
        const message = errorData?.message || (typeof errorData === "string" ? errorData : null)
          || error?.message || "Không thể xóa khoản thu.";
        NotifyMessage.leftCornerNotificationError(typeof message === "string" ? message : JSON.stringify(message));
        await this.handleSearch();
      } finally {
        this.isDeletingFee = false;
      }
    },

    async handleFeeRenamed(result) {
      const newName = result.newRevenueName || result.newName;
      await this.handleSearch();
      NotifyMessage.leftCornerNotificationSuccess(
        `Đã đổi tên khoản thu thành "${newName}" trên ${result.updatedInvoiceCount || 0} phiếu thu.`
      );
      if (result.auditFailedCount > 0) {
        NotifyMessage.leftCornerNotificationWarning(
          `${result.auditFailedCount} phiếu chưa ghi được lịch sử thao tác; vui lòng kiểm tra nhật ký 9096.`
        );
      }
    },

    async handleFeeDeleted(result) {
      const feeName = result.label || result.revenueName || result.revenueCode || "";
      await this.handleSearch();
      NotifyMessage.leftCornerNotificationSuccess(
        `Đã xóa khoản "${feeName}" trên ${result.updatedInvoiceCount || 0} phiếu thu.`
      );
      if (result.auditFailedCount > 0) {
        NotifyMessage.leftCornerNotificationWarning(
          `${result.auditFailedCount} phiếu chưa ghi được lịch sử thao tác; vui lòng kiểm tra nhật ký 9096.`
        );
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    async handleHideReceiptChange(row) {
      const originalHideReceipt = !row.hideReceipt;
      const payload = [
        {
          idx: row.idx,
          hideReceipt: row.hideReceipt,
        },
      ];

      try {
        const response = await ManagingStudentInvoiceService.updateHideReceipt(payload);
        if (response?.data?.data === true) {
          NotifyMessage.leftCornerNotificationSuccess(
            `${row.hideReceipt ? "Hiển thị" : "Ẩn"} phiếu thu ${row.invoiceCode} thành công.`
          );
        } else {
          throw new Error("Cập nhật thất bại.");
        }
      } catch (error) {
        console.error(error);
        row.hideReceipt = originalHideReceipt;
        NotifyMessage.leftCornerNotificationError("Cập nhật trạng thái ẩn/hiện phiếu thu thất bại.");
      }
    },

    handleBatchCommand(command) {
      if (command === "batch_pay") {
        this.handleBatchPay();
      } else if (command === "hide") {
        this.handleBatchHide(false);
      } else if (command === "show") {
        this.handleBatchHide(true);
      } else if (command === "note") {
        this.handleBatchNote();
      } else if (command === "print_1") {
        this.handleBatchPrint(1);
      } else if (command === "print_2") {
        this.handleBatchPrint(2);
      } else if (command === "registerBank") {
        this.handleBatchRegisterBank();
      } else if (command === "cancel") {
        this.handleBatchCancel();
      } else if (command === "restore") {
        this.handleBatchRestore();
      } else if (command === "delete") {
        this.handleBatchDelete();
      } else if (command === "send_onekids") {
        this.handleBatchSendOnekids();
      } else if (command === "send_sms") {
        this.handleBatchSendSMS();
      } else if (command === "export_excel_selected") {
        this.handleBatchExportExcelSelected();
      } else if (command === "createManyDraft") {
        this.handleCreateManyDraftInvoice();
      } else if (command === "sync_attendance") {
        this.handleSyncAttendance();
      } else if (command === "import_excel") {
        this.handleOpenExcelImportWizard();
      } else if (command === "add_batch_revenue") {
        this.handleOpenAddBatchRevenueDialog();
      } else if (command === "init_student_invoice") {
        this.handleBatchInitInvoice();
      }
    },

    handleOpenAddBatchRevenueDialog() {
      const context = this.getFeeActionContext();
      if (!context) return;
      const invoiceCount = (Array.isArray(this.tableData) ? this.tableData : [])
        .filter((row) => row.idx && row.status !== "DELETE").length;
      this.$refs.addBatchRevenueDialog.open({ ...context, invoiceCount });
    },

    async handleBatchRevenueAdded(result) {
      await this.handleSearch();
      NotifyMessage.leftCornerNotificationSuccess(
        `Đã thêm khoản thu "${result.revenueName}" trên ${result.updatedInvoiceCount} phiếu thu.`
      );
      if (result.auditFailedCount > 0) NotifyMessage.leftCornerNotificationWarning(`${result.auditFailedCount} phiếu chưa ghi được lịch sử thao tác.`);
    },

    async handleBatchInitInvoice() {
      if (this.isPackageMode) {
        NotifyMessage.leftCornerNotificationError("Tính năng khởi tạo khoản thu không áp dụng cho chế độ gói.");
        return;
      }

      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có học sinh nào được chọn!");
        return;
      }

      // Chỉ có học sinh chưa có phiếu thu mới được phép sử dụng chức năng này
      const billedStudents = this.multipleSelection.filter(
        (row) =>
          (row.status && row.status !== "UNBILLED") ||
          (row.idx && row.idx !== "") ||
          (row.invoiceCode && row.invoiceCode !== "-")
      );

      if (billedStudents.length > 0) {
        NotifyMessage.leftCornerNotificationWarning(
          `Chức năng chỉ áp dụng cho học sinh chưa có phiếu thu. Vui lòng bỏ chọn ${billedStudents.length} học sinh đã có phiếu thu!`
        );
        return;
      }

      const validStudents = this.multipleSelection.filter((row) => !!row.studentCode);
      if (validStudents.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Các học sinh được chọn không có mã học sinh hợp lệ.");
        return;
      }

      // Đảm bảo mã học sinh không rỗng và không trùng lặp
      const studentCodeMap = new Map();
      validStudents.forEach((student) => {
        const code = (student.studentCode || "").trim();
        if (code && !studentCodeMap.has(code)) {
          studentCodeMap.set(code, student.fullName || code);
        }
      });

      const uniqueStudentCodes = Array.from(studentCodeMap.keys());
      if (uniqueStudentCodes.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không có mã học sinh hợp lệ để khởi tạo khoản thu.");
        return;
      }

      this.parseMonthAndYear();
      const month = Number(this.searchRequest.month);
      const year = Number(this.searchRequest.year);
      const turn = Number(this.searchRequest.turn);

      if (!month || !year || !turn) {
        NotifyMessage.leftCornerNotificationWarning(
          "Vui lòng chọn đầy đủ Tháng, Năm và Đợt thu trong bộ lọc trước khi khởi tạo khoản thu!"
        );
        return;
      }

      const totalCount = uniqueStudentCodes.length;
      try {
        await this.$confirm(
          `Bạn có chắc chắn muốn khởi tạo khoản thu cho ${totalCount} học sinh chưa có phiếu thu (Tháng ${month}/${year} - Đợt ${turn}) từ phiếu thu mẫu cùng lớp?`,
          "Xác nhận khởi tạo khoản thu",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "warning",
          }
        );
      } catch {
        return;
      }

      const loadingInstance = this.$loading({
        lock: true,
        text: `Đang khởi tạo khoản thu cho ${totalCount} học sinh...`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let totalSuccess = 0;
      let totalFailed = 0;
      const errorDetails = [];

      try {
        // API copy-for-students hỗ trợ 1–100 học sinh trong một lần gọi
        const CHUNK_SIZE = 100;
        for (let i = 0; i < uniqueStudentCodes.length; i += CHUNK_SIZE) {
          const chunk = uniqueStudentCodes.slice(i, i + CHUNK_SIZE);
          const payload = {
            studentCodes: chunk,
            month,
            year,
            turn,
          };

          try {
            const response = await ManagingStudentInvoiceService.copyForStudents(payload);
            const resData = response?.data?.data || response?.data || {};
            const results = Array.isArray(resData.results) ? resData.results : [];

            if (results.length > 0) {
              results.forEach((item) => {
                if (item.success) {
                  totalSuccess++;
                } else {
                  totalFailed++;
                  const studentName = studentCodeMap.get(item.studentCode) || item.studentCode;
                  const msg = item.message || "Không thể tạo phiếu";
                  errorDetails.push(`${studentName}: ${msg}`);
                }
              });
            } else {
              const sc = Number(resData.successCount || 0);
              const fc = Number(resData.failedCount || (chunk.length - sc));
              totalSuccess += sc;
              totalFailed += fc;
            }
          } catch (err) {
            totalFailed += chunk.length;
            const msg =
              err?.response?.data?.message ||
              err?.message ||
              "Lỗi kết nối khi khởi tạo khoản thu";
            errorDetails.push(msg);
          }
        }
      } finally {
        loadingInstance.close();
      }

      if (totalSuccess > 0 && totalFailed === 0) {
        NotifyMessage.leftCornerNotificationSuccess(
          `Khởi tạo khoản thu thành công cho ${totalSuccess} học sinh.`
        );
      } else if (totalSuccess > 0 && totalFailed > 0) {
        const errorSummary =
          errorDetails.length <= 3
            ? errorDetails.join("; ")
            : `${errorDetails.slice(0, 2).join("; ")} (và ${errorDetails.length - 2} lỗi khác)`;
        NotifyMessage.leftCornerNotificationWarning(
          `Khởi tạo thành công ${totalSuccess}/${totalCount} học sinh. Thất bại ${totalFailed} học sinh: ${errorSummary}`
        );
      } else {
        const firstErr = errorDetails[0] ? `: ${errorDetails[0]}` : "";
        NotifyMessage.leftCornerNotificationError(
          `Khởi tạo khoản thu thất bại${firstErr}.`
        );
      }

      this.clearTableSelection();
      await this.handleSearch();
    },

    handleOpenExcelImportWizard() {
      if (this.isPackageMode) {
        NotifyMessage.leftCornerNotificationError("Tính năng nhập từ Excel chỉ áp dụng cho phạm vi Lớp và Nhóm.");
        return;
      }
      const monthParts = (this.searchRequest.monthAndYear || "").split("-");
      // Trích xuất danh sách học sinh (ưu tiên danh sách được chọn ở checkbox tác vụ hàng loạt nếu có)
      const sourceList =
        this.multipleSelection && this.multipleSelection.length > 0
          ? this.multipleSelection
          : Array.isArray(this.tableData)
          ? this.tableData
          : [];
      const candidateStudents = sourceList.map((row) => ({
        ...row,
        id: row.idStudent,
        idStudent: row.idStudent,
        studentCode: row.studentCode,
        fullName: row.fullName,
        className: row.className,
        nickName: row.nickName,
        birthday: row.birthday,
        phone: row.parentPhone,
        beforeMoney: row.beforeMoney,
        arriveT2t6: row.arriveT2t6,
        arriveT7: row.arriveT7,
        arriveCn: row.arriveCn,
        absentCpT2t6: row.absentCpT2t6,
        absentKpT2t6: row.absentKpT2t6,
        absentCpT7: row.absentCpT7,
        absentKpT7: row.absentKpT7,
        leaveLater: row.leaveLater,
        quantityDate: row.quantityDate,
        invoiceDetails: Array.isArray(row.invoiceDetails) ? row.invoiceDetails : [],
      }));

      // Trích xuất danh sách các khoản thu đang có ngoài màn hình chính để đối soát:
      // Mã khoản thu là revenueCode, Mã định danh là idx
      const currentFeeColumns = (Array.isArray(this.feeColumns) ? this.feeColumns : []).map((col) => ({
        name: col.label,
        revenueName: col.label,
        revenueCode: col.revenueCode || col.key, // Mã khoản thu (revenueCode)
        idx: col.idx || "", // Mã định danh (idx)
        unit: col.unit || "Tháng",
        price: col.price || 0,
        isCustom: false,
        isExternal: true, // Khoản thu từ màn chính -> KHÔNG ĐƯỢC XÓA
      }));

      // Lấy tên lớp hoặc nhóm đang lọc ngoài
      let scopeName = "";
      if (this.searchRequest.targetType === "CLASS") {
        const cls = this.classList.find((c) => c.id === this.searchRequest.idClass);
        scopeName = cls ? cls.className : "";
      } else if (this.searchRequest.targetType === "GROUP") {
        const grp = this.kidGroupList.find((g) => g.id === this.searchRequest.idGroup);
        scopeName = grp ? grp.nameGroup : "";
      }

      const outsideTurn = this.searchRequest.turn ? Number(this.searchRequest.turn) : 1;

      this.$refs.invoiceExcelImportWizardDialog.open({
        targetType: this.searchRequest.targetType === "GROUP" ? "GROUP" : "CLASS",
        scopeName: scopeName,
        idGrade: this.searchRequest.idGrade,
        idClass: this.searchRequest.idClass,
        idGroup: this.searchRequest.idGroup,
        month: monthParts[0] ? Number(monthParts[0]) : moment().month() + 1,
        year: monthParts[1] ? Number(monthParts[1]) : moment().year(),
        turn: outsideTurn,
        candidateStudents: candidateStudents,
        externalFeeColumns: currentFeeColumns,
      });
    },

    async handleImportedSuccess(context) {
      if (context && context.turn) {
        this.searchRequest.turn = Number(context.turn);
      }
      await this.reloadAllData();
    },

    async handleImportWizardClose() {
      await this.reloadAllData();
    },

    /**
     * Tải lại toàn bộ dữ liệu màn chính giống như khi ấn F5
     */
    async reloadAllData() {
      if (this.isReloadingAllData) return;
      this.isReloadingAllData = true;
      try {
        await Promise.all([
          this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList"),
          this.$store.dispatch("classStore/fetchDataClassListCommon"),
          this.$store.dispatch("schoolStore/fetchDataSchoolData", ""),
          this.fetchGroups(),
          this.fetchPackages(),
        ]);
        await this.fetchMaxTurn();
        await this.handleSearch();
      } catch (err) {
        console.error("Lỗi khi tải lại dữ liệu:", err);
      } finally {
        this.isReloadingAllData = false;
      }
    },

    /**
     * Nhận danh sách phiếu thu DB sinh từ Excel và nạp vào tableData trên FE
     */
    handleImportedMockData(importedInvoices) {
      if (!Array.isArray(importedInvoices) || importedInvoices.length === 0) return;

      const normalizedImported = this.normalizeInvoiceList(importedInvoices);
      const combinedRaw = [...normalizedImported, ...this.tableData];

      // Tái tính toán các cột khoản thu động để bao gồm cả các khoản mới
      this.feeColumns = this.normalizeFeeColumns(combinedRaw);
      this.tableData = combinedRaw.map((item) => this.normalizeInvoiceRow(item, this.feeColumns));
      this.totalRecord = this.tableData.length;
    },

    async handleSyncAttendance(){
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }
      this.$confirm(
          `Bạn có chắc chắn muốn đồng bộ dữ liệu diểm danh các phiếu thu đã chọn không?`,
          "Xác nhận",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      )
          .then(async () => {
            let idxList = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              idxList.push(this.multipleSelection[i].idx);
            }
            let data = {
              idxList: idxList
            }
            try {
              const response = await ManagingStudentInvoiceService.syncAttendance(data);
              if (response?.data?.data === true) {
                NotifyMessage.leftCornerNotificationSuccess(
                    `Đồng bộ dữ liệu điểm danh cho các phiếu thu thành công.`
                );
                this.clearTableSelection();
                await this.handleSearch();
              } else {
                NotifyMessage.leftCornerNotificationError(`Đồng bộ dữ liệu điểm danh cho các phiếu thu thất bại.`);
              }
            } catch (error) {
              console.error(error);
              NotifyMessage.leftCornerNotificationError(`Không thể đồng bộ dữ liêu điểm danh cho các phiếu thu đã chọn.`);
            }
          })
          .catch(() => {
            // Cancelled confirmation
          });
    },

    async handleBatchExportExcelSelected() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }
      
      this.isLoading = true;
      try {
        // Mock loading delay to ensure indicator is visible
        await new Promise(resolve => setTimeout(resolve, 500));
        
        await exportSelectedStudentsExcel({
          invoices: this.multipleSelection,
          schoolInfo: this.schoolInfo,
          feeColumns: this.feeColumns,
          title: "DANH SÁCH PHIẾU THU HỌC SINH"
        });
        NotifyMessage.leftCornerNotificationSuccess("Xuất excel thành công.");
        this.clearTableSelection();
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Có lỗi xảy ra khi xuất excel.");
      } finally {
        this.isLoading = false;
      }
    },

    handleBatchSendOnekids() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.idx && row.hideReceipt === true
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu đã phát hành và đang ở trạng thái hiển thị để gửi học phí.");
        return;
      }

      const idxList = validSelected.map((row) => row.idx);
      this.$refs.sendAppInvoiceDialog.open(idxList);
    },

    handleBatchPay() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.status !== "FULLY_PAID" && row.idx
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không có phiếu thu nào hợp lệ để thanh toán hàng loạt (chưa phát hành hoặc đã thanh toán đủ).");
        return;
      }

      const idxList = validSelected.map((row) => row.idx);
      const idKidList = validSelected.map((row) => row.idStudent);
      this.$refs.batchPaymentDialog.open(idxList, idKidList);
    },

    handleBatchSendSMS() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.idx && row.hideReceipt === true
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu đã phát hành và đang ở trạng thái hiển thị để gửi học phí.");
        return;
      }

      this.$confirm(
        "Số lượng tin nhắn sẽ bị trừ vào quỹ tin của nhà trường! Bạn có chắc chắn muốn gửi SMS học phí cho các học sinh đã chọn?",
        "Xác nhận gửi SMS",
        {
          confirmButtonText: "Gửi",
          cancelButtonText: "Hủy",
          type: "warning",
        }
      ).then(async () => {
        const payload = {
          idxList: validSelected.map((row) => row.idx),
        };

        try {
          const response = await ManagingStudentInvoiceService.sendSmsForInvoices(payload);
          if (response?.data?.data === true) {
            NotifyMessage.leftCornerNotificationSuccess("Gửi SMS thông báo học phí thành công.");
            this.clearTableSelection();
          } else {
            const errorMsg = response?.data?.message || "Gửi SMS thất bại.";
            throw new Error(errorMsg);
          }
        } catch (error) {
          console.error(error);
          const errorMsg = error?.response?.data?.message || error.message || "Không thể gửi SMS cho các phiếu thu đã chọn.";
          NotifyMessage.leftCornerNotificationError(errorMsg);
        }
      }).catch(() => {});
    },

    handleBatchNote() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.idx
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu đã phát hành để tạo ghi chú.");
        return;
      }

      const idxList = validSelected.map((row) => row.idx);
      this.$refs.batchUpdateNoteDialog.open(idxList);
    },

    handleBatchRegisterBank() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.idx
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu đã phát hành để áp dụng tài khoản.");
        return;
      }

      const idxList = validSelected.map((row) => row.idx);
      this.$refs.registerBankForOrderDialog.open({
        idxList,
      });
    },

    async handleBatchPrint(copies) {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.idx
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu đã phát hành để in.");
        return;
      }

      const idxList = validSelected.map((row) => row.idx);

      try {
        const response = await ManagingStudentInvoiceService.getBatchDetail({ idxList });
        if (response?.data?.status === 200 || response?.data?.code === "0") {
          const apiData = response.data.data;
          
          const batchPrintData = {
            companyName: apiData.companyName || "ONEKIDS-ONECAM",
            appName: apiData.appName || "OneKids",
            copies: copies,
            invoices: apiData.invoices || []
          };

          localStorage.setItem("tuition_batch_print_data", JSON.stringify(batchPrintData));
          
          const routeData = this.$router.resolve({ path: '/tuition-batch-invoice-print' });
          window.open(routeData.href, '_blank');
          this.clearTableSelection();
        } else {
          throw new Error("Không lấy được dữ liệu in hàng loạt");
        }
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Lỗi khi tải dữ liệu in phiếu thu.");
      }
    },

    handleBatchHide(hideReceipt) {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const actionName = hideReceipt ? "Hiển thị" : "Ẩn";
      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED"
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu hợp lệ để cập nhật.");
        return;
      }

      this.$confirm(
        `Bạn có chắc chắn muốn ${actionName.toLowerCase()} các phiếu thu đã chọn không?`,
        "Xác nhận",
        {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "Có",
          cancelButtonText: "Không",
        }
      )
        .then(async () => {
          const payload = validSelected.map((row) => ({
            idx: row.idx,
            hideReceipt: hideReceipt,
          }));

          try {
            const response = await ManagingStudentInvoiceService.updateHideReceipt(payload);
            if (response?.data?.data === true) {
              NotifyMessage.leftCornerNotificationSuccess(
                `${actionName} các phiếu thu thành công.`
              );
              this.clearTableSelection();
              await this.handleSearch();
            } else {
              throw new Error("Cập nhật thất bại.");
            }
          } catch (error) {
            console.error(error);
            NotifyMessage.leftCornerNotificationError(`Không thể ${actionName.toLowerCase()} các phiếu thu đã chọn.`);
          }
        })
        .catch(() => {
          // Cancelled confirmation
        });
    },

    handleBatchCancel() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      // Toàn bộ phiếu thu được chọn phải: khác UNBILLED, khác HIDE, và hideReceipt = true
      const allValid = this.multipleSelection.every(
        (row) => row.status !== "UNBILLED" && row.status !== "HIDE" && row.hideReceipt === true
      );

      if (!allValid) {
        NotifyMessage.leftCornerNotificationWarning("Tất cả phiếu thu được chọn phải đang hoạt động (không phải Chưa có phiếu thu, không phải Ẩn) và đang ở trạng thái hiển thị để thực hiện huỷ.");
        return;
      }

      const validSelected = this.multipleSelection.filter((row) => row.idx);

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy phiếu thu hợp lệ để huỷ.");
        return;
      }

      this.$confirm(
        `Bạn có chắc chắn muốn huỷ ${validSelected.length} phiếu thu đã chọn không? Trạng thái phiếu thu sẽ được chuyển sang Ẩn.`,
        "Xác nhận",
        {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "Có",
          cancelButtonText: "Không",
        }
      )
        .then(async () => {
          const payload = {
            idxList: validSelected.map((row) => row.idx),
          };

          try {
            const response = await ManagingStudentInvoiceService.cancelInvoices(payload);
            if (response?.data?.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Huỷ các phiếu thu thành công.");
              this.clearTableSelection();
              await this.handleSearch();
            } else {
              const errorMsg = response?.data?.message || "Huỷ các phiếu thu thất bại.";
              throw new Error(errorMsg);
            }
          } catch (error) {
            console.error(error);
            const errorMsg = error?.response?.data?.message || error.message || "Không thể huỷ các phiếu thu đã chọn.";
            NotifyMessage.leftCornerNotificationError(errorMsg);
          }
        })
        .catch(() => {
          // Cancelled confirmation
        });
    },

    handleBatchRestore() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      // Toàn bộ phiếu thu được chọn phải ở trạng thái Ẩn (HIDE)
      const allValid = this.multipleSelection.every(
        (row) => row.status === "HIDE"
      );

      if (!allValid) {
        NotifyMessage.leftCornerNotificationWarning("Tất cả phiếu thu được chọn phải ở trạng thái Ẩn để thực hiện khôi phục.");
        return;
      }

      const validSelected = this.multipleSelection.filter((row) => row.idx);

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy phiếu thu hợp lệ để khôi phục.");
        return;
      }

      this.$confirm(
        `Bạn có chắc chắn muốn khôi phục ${validSelected.length} phiếu thu đang ẩn đã chọn về trạng thái Chưa thanh toán không?`,
        "Xác nhận",
        {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "Có",
          cancelButtonText: "Không",
        }
      )
        .then(async () => {
          const payload = {
            idxList: validSelected.map((row) => row.idx),
          };

          try {
            const response = await ManagingStudentInvoiceService.restoreInvoices(payload);
            if (response?.data?.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Khôi phục các phiếu thu thành công.");
              this.clearTableSelection();
              await this.handleSearch();
            } else {
              const errorMsg = response?.data?.message || "Khôi phục các phiếu thu thất bại.";
              throw new Error(errorMsg);
            }
          } catch (error) {
            console.error(error);
            const errorMsg = error?.response?.data?.message || error.message || "Không thể khôi phục các phiếu thu đã chọn.";
            NotifyMessage.leftCornerNotificationError(errorMsg);
          }
        })
        .catch(() => {
          // Cancelled confirmation
        });
    },

    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      // Toàn bộ phiếu thu được chọn phải ở trạng thái Ẩn (HIDE)
      const allValid = this.multipleSelection.every(
        (row) => row.status === "HIDE"
      );

      if (!allValid) {
        NotifyMessage.leftCornerNotificationWarning("Tất cả phiếu thu được chọn phải ở trạng thái Ẩn để thực hiện xoá.");
        return;
      }

      const validSelected = this.multipleSelection.filter((row) => row.idx);

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy phiếu thu hợp lệ để xoá.");
        return;
      }

      this.$confirm(
        `Bạn có chắc chắn muốn xoá ${validSelected.length} phiếu thu đang ẩn đã chọn không? Hành động này không thể hoàn tác.`,
        "Xác nhận",
        {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "Có",
          cancelButtonText: "Không",
        }
      )
        .then(async () => {
          const payload = {
            idxList: validSelected.map((row) => row.idx),
          };

          try {
            const response = await ManagingStudentInvoiceService.deleteInvoices(payload);
            if (response?.data?.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Xoá các phiếu thu thành công.");
              this.clearTableSelection();
              await this.handleSearch();
            } else {
              const errorMsg = response?.data?.message || "Xoá các phiếu thu thất bại.";
              throw new Error(errorMsg);
            }
          } catch (error) {
            console.error(error);
            const errorMsg = error?.response?.data?.message || error.message || "Không thể xoá các phiếu thu đã chọn.";
            NotifyMessage.leftCornerNotificationError(errorMsg);
          }
        })
        .catch(() => {
          // Cancelled confirmation
        });
    },

    handlePayment(row) {
      this.$refs.invoicePaymentDialog.open(row);
    },

    handleActionHistory(row) {
      if (!row || !row.idx) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn phiếu thu hợp lệ.");
        return;
      }
      this.$refs.invoiceActionHistoryDialog.open(row);
    },

    handlePaymentHistory(row) {
      this.$refs.invoicePaymentHistoryDialog.open(row);
    },

    handleOpenUnpaidDialog(row) {
      this.$refs.unpaidInvoicesDialog.open(row, this.searchRequest.targetType);
    },

    handleOpenHistoryDialog(row) {
      const currentTargetId = this.searchRequest.targetType === 'CLASS' ? this.searchRequest.idClass : this.searchRequest.idGroup;
      this.$refs.studentInvoiceHistoryDialog.open(row, this.searchRequest.targetType, currentTargetId);
    },

    clearTableSelection() {
      this.multipleSelection = [];
      if (this.$refs.invoiceTableRef) {
        this.$refs.invoiceTableRef.clearSelection();
      }
    },

    // ─── Tạo nhiều hóa đơn nháp ──────────────────────────────────
    checkPermission,

    handleCreateManyDraftInvoice() {
      if (this.multipleSelection.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Chưa có phiếu thu nào được chọn!");
        return;
      }

      const validSelected = this.multipleSelection.filter(
        (row) => row.status !== "UNBILLED" && row.studentCode
      );

      if (validSelected.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy mã học sinh hợp lệ trong danh sách đã chọn.");
        return;
      }

      this.selectedKidCodes = validSelected.map((row) => row.studentCode).filter(Boolean);
      if (this.selectedKidCodes.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy mã học sinh trong danh sách đã chọn.");
        return;
      }

      this.isOpenInvoiceCreateManyDialog = true;
    },

    closeInvoiceCreateManyDialog() {
      this.isOpenInvoiceCreateManyDialog = false;
      this.selectedKidCodes = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

/* =====================================================
   TuitionDraftInvoice – Prefix: tdi-
   ===================================================== */

.tdi-page {
  padding: 4px 0 24px;
  .row-data { margin-bottom: 20px; }
}

/* ─── Toolbar card ─────────────────────────────────── */
.tdi-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px;
}

/* ─── Card head actions ────────────────────────────── */
.tdi-card-head-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tdi-reset-btn {
  border-radius: 8px;
  font-weight: 500;
  color: #475569;
  border-color: #cbd5e1;
  background: #f8fafc;
  transition: all 0.2s ease;

  &:hover {
    color: #2563eb;
    border-color: #93c5fd;
    background: #eff6ff;
  }
}

/* ─── Table card ───────────────────────────────────── */
.tdi-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px 16px;
}

/* ─── Card head ────────────────────────────────────── */
.tdi-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.tdi-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.tdi-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.6;
  color: #64748b;
}

/* ─── Form grid ────────────────────────────────────── */
.tdi-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.tdi-form-grid--package {
  flex-wrap: wrap;
  overflow-x: visible;
}

.tdi-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .tdi-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
}

/* ─── Segmented Control ────────────────────────────── */
/deep/ .sk-segmented-control {
  background: #f1f5f9;
  padding: 3px;
  border-radius: 10px;
  display: inline-flex;
  border: 1px solid #e2e8f0;
  
  .el-radio-button {
    margin: 0;
    
    .el-radio-button__inner {
      background: transparent !important;
      border: none !important;
      color: #64748b !important;
      font-weight: 600;
      font-size: 12.5px;
      padding: 6px 16px !important;
      border-radius: 8px !important;
      transition: all 0.2s ease;
      box-shadow: none !important;
    }
    
    &.is-active .el-radio-button__inner {
      background: #ffffff !important;
      color: #2563eb !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06) !important;
    }
  }
}

/* ─── Premium Tag Styles ───────────────────────────── */
/deep/ .el-tag {
  border-radius: 6px !important;
  font-weight: 600;
  padding: 0 10px;
  height: 24px;
  line-height: 22px;
  border-width: 1px;
}

/deep/ .el-tag--success {
  background-color: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
  color: #15803d !important;
}

/deep/ .el-tag--danger {
  background-color: #fef2f2 !important;
  border-color: #fecaca !important;
  color: #b91c1c !important;
}

/deep/ .el-tag--warning {
  background-color: #fffbeb !important;
  border-color: #fef3c7 !important;
  color: #b45309 !important;
}

/deep/ .el-tag--info {
  background-color: #f8fafc !important;
  border-color: #cbd5e1 !important;
  color: #475569 !important;
}

/* ─── Active Filter Highlighting & Reset Button ────── */
/deep/ .tdi-form-item.is-filter-active {
  .el-input__inner {
    border-color: #3b82f6 !important;
    background-color: #f0f7ff !important;
    font-weight: 600;
  }
}

.tdi-reset-btn {
  background: #f1f5f9 !important;
  border: 1px solid #cbd5e1 !important;
  color: #475569 !important;
  font-weight: 600 !important;
  height: 32px !important;
  line-height: 1 !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
  
  &:hover {
    background: #e2e8f0 !important;
    border-color: #94a3b8 !important;
    color: #1e293b !important;
  }
}

/* ─── Action row ──────────────────────────────────── */
.tdi-action-row {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
}

/* ─── Notes section ────────────────────────────────── */
.tdi-notes-section {
  margin-top: 20px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f7ff 100%);
  border: 1px solid #e2e8f0;
  border-left: 4px solid #3b82f6;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);

  .tdi-notes-title {
    margin: 0 0 10px;
    font-size: 13.5px;
    font-weight: 700;
    color: #1d4ed8;
    display: flex;
    align-items: center;
    gap: 6px;

    i {
      font-size: 16px;
      color: #3b82f6;
      margin-right: 0;
    }
  }

  .tdi-notes-list {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      font-size: 12.5px;
      line-height: 1.8;
      color: #475569;
      position: relative;
      padding-left: 16px;
      margin-bottom: 6px;
      text-align: left;

      &:last-child {
        margin-bottom: 0;
      }

      &::before {
        content: "•";
        position: absolute;
        left: 4px;
        color: #3b82f6;
        font-weight: bold;
        font-size: 14px;
      }

      strong {
        color: #1e293b;
        font-weight: 600;
      }

      em {
        color: #2563eb;
        font-style: normal;
        font-weight: 600;
        background: #eff6ff;
        padding: 1px 6px;
        border-radius: 4px;
      }
    }
  }
}

/* ─── Row Hover Accent Line ────────────────────────── */
/deep/ .sk-table tbody tr.hover-row {
  & > td {
    background-color: #f0f7ff !important;
  }
  
  & > td:first-child {
    position: relative;
    
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 4px;
      background-color: #3b82f6;
      z-index: 10;
    }
  }
}

/* ─── Table wrapper ────────────────────────────────── */
.tdi-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

/* ─── Money & Text helpers ─────────────────────────── */
.tdi-student-name-cell {
  font-weight: 700;
  color: #0f172a;
  font-size: 13.5px;
}
.tdi-money,
.tdi-money--bold,
.tdi-money--negative,
.tdi-money--positive {
  font-variant-numeric: tabular-nums;
  font-size: 13px;
}
.tdi-money {
  color: #475569;
}
.tdi-money--bold     { font-weight: 700; color: #1e293b; }
.tdi-money--negative { color: #dc2626; font-weight: 600; }
.tdi-money--positive { color: #16a34a; font-weight: 600; }
.tdi-text-muted      { color: #94a3b8; font-size: 13px; }


/* ─── Table header: xanh primary ──────────────────── */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead tr    { height: 52px; }
/deep/ .sk-table tbody td    { background: #ffffff; }

/* Summary row */
/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}
/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}

/* ─── Input / Button ──────────────────────────────── */
/deep/ .tdi-page .el-input__inner,
/deep/ .tdi-page .el-select .el-input__inner { border-radius: 10px; }
/deep/ .tdi-page .el-button { border-radius: 10px; }
/deep/ .tdi-page .el-radio-button__inner { border-radius: 0; }
/deep/ .tdi-page .el-radio-group .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 10px 0 0 10px;
}
/deep/ .tdi-page .el-radio-group .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 10px 10px 0;
}

/* ─── Finance column styling ──────────────────────── */
/deep/ .sk-table thead th.tdi-finance-header,
/deep/ .sk-table thead td.tdi-finance-header {
  background: #0f766e !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table thead th.tdi-finance-header > .cell,
/deep/ .sk-table thead td.tdi-finance-header > .cell {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table tbody td.tdi-finance-column {
  background-color: #f0fdfa !important;
}

/* ─── Fee column styling ─────────────────────────── */
/deep/ .sk-table thead th.tdi-fee-header,
/deep/ .sk-table thead td.tdi-fee-header {
  background: #6d28d9 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  cursor: default !important;
}

/deep/ .sk-table thead th.tdi-fee-header > .cell,
/deep/ .sk-table thead td.tdi-fee-header > .cell {
  color: #ffffff !important;
  font-weight: 700 !important;
  cursor: default !important;
}

/* Chỉ hiển thị pointer khi có quyền và không ở tab gói (is-clickable-header) */
/deep/ .sk-table thead th.tdi-fee-header.is-clickable-header,
/deep/ .sk-table thead th.tdi-fee-header.is-clickable-header > .cell,
/deep/ .sk-table thead th.tdi-fee-header.is-clickable-header .tdi-fee-header-text.is-clickable {
  cursor: pointer !important;
}

/deep/ .sk-table thead th.tdi-fee-header.is-not-clickable,
/deep/ .sk-table thead th.tdi-fee-header.is-not-clickable > .cell,
/deep/ .sk-table thead th.tdi-fee-header.is-not-clickable .tdi-fee-header-text,
/deep/ .tdi-table--package thead th.tdi-fee-header,
/deep/ .tdi-table--package thead th.tdi-fee-header > .cell,
/deep/ .tdi-table--package thead th.tdi-fee-header .tdi-fee-header-text {
  cursor: default !important;
  user-select: none;
}

/deep/ .sk-table tbody td.tdi-fee-column {
  background-color: #f5f3ff !important;
}

/deep/ .sk-table tbody td.tdi-fee-column .cell {
  color: #5b21b6;
  font-weight: 600;
}

/deep/ .tdi-fee-amount {
  width: 100%;
  padding: 12px 8px;
  color: #6d28d9;
  font-weight: 600;
  text-align: right;
  display: block;
  border: none;
  background: transparent;
}

/deep/ .tdi-fee-amount:hover {
  color: #4c1d95;
  text-decoration: underline;
}

/deep/ .tdi-fee-amount.is-disabled,
/deep/ .tdi-fee-amount.is-disabled:hover {
  color: #cbd5e1;
  text-decoration: none;
  cursor: not-allowed;
}

.tdi-money--fee {
  color: #6d28d9;
  font-weight: 700;
}

.tdi-fee-header-text {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;

  &.is-clickable {
    cursor: pointer;
  }
}

/deep/ .tdi-table--package .tdi-fee-header-text,
/deep/ .tdi-table--package .tdi-fee-header-text.is-clickable {
  cursor: default !important;
}

.tdi-additional-info-btn {
  font-size: 16px;
  color: #2563eb;
}

.tdi-unpaid-badge {
  display: inline-block;
  padding: 4px 10px;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 12.5px;
  cursor: pointer;
  border: 1px solid #bfdbfe;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.05);
  user-select: none;
}

.tdi-unpaid-badge:hover {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
}

.tdi-unpaid-badge:active {
  transform: translateY(0);
}

.tdi-unpaid-zero {
  color: #94a3b8;
  font-weight: 500;
  font-size: 13px;
}

.tdi-action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.tdi-selection-count {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
  background: #f0f9ff;
  border: 1px solid #e0f2fe;
  padding: 6px 12px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.tdi-selection-count strong {
  color: #0284c7;
}

/* ─── Batch action dropdown ────────────────────────── */
.tdi-batch-action-btn {
  background: #f0f9ff !important;
  border: 1px solid #bae6fd !important;
  border-radius: 8px !important;
  padding: 8px 14px !important;
  font-size: 12.5px !important;
  font-weight: 600 !important;
  color: #0369a1 !important;
  height: 34px !important;
  line-height: 1 !important;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(3, 105, 161, 0.05);
}

.tdi-batch-action-btn:hover,
.tdi-batch-action-btn:focus {
  background: #e0f2fe !important;
  border-color: #7dd3fc !important;
  color: #0284c7 !important;
  box-shadow: 0 2px 4px rgba(3, 105, 161, 0.1);
}
</style>

<!-- Global (unscoped) styles for el-dropdown-menu popper -->
<style lang="scss">
.tdi-batch-dropdown.el-dropdown-menu {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  border: 1px solid #cbd5e1 !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05) !important;
  padding: 4px 0 !important;
  min-width: 185px !important;

  .el-dropdown-menu__item {
    padding: 9px 16px !important;
    font-size: 13px !important;
    color: #334155 !important;
    border-radius: 0 !important;
    margin: 0 !important;
    transition: all 0.15s ease !important;
    font-weight: 500 !important;
    line-height: 1.5 !important;
    background: transparent !important;
    border-bottom: 1px solid #f1f5f9 !important;

    i {
      font-size: 14px !important;
      color: #64748b !important;
      margin-right: 6px !important;
    }

    &:hover,
    &:focus {
      background: #f1f5f9 !important;
      color: #0f172a !important;

      i { color: #0f172a !important; }
    }

    &.is-disabled {
      color: #cbd5e1 !important;
      i { color: #cbd5e1 !important; }
    }
  }

  /* Remove border for the very last item in the entire dropdown menu */
  & > .el-dropdown-menu__item:last-child,
  & > .el-dropdown:last-child .el-dropdown-menu__item {
    border-bottom: none !important;
  }

  .tdi-nested-menu-item {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9 !important;

    .tdi-nested-menu-label {
      display: flex;
      align-items: center;
    }

    i.el-icon-arrow-left {
      margin-left: auto;
      margin-right: 0 !important;
    }
  }

  .el-dropdown {
    width: 100%;
    display: block;
    &:focus {
      outline: none;
    }
  }

  .popper__arrow { display: none !important; }
}
</style>
